import { render, staticRenderFns } from "./audio-bar.vue?vue&type=template&id=6d8ab9ec&scoped=true&"
import script from "./audio-bar.vue?vue&type=script&lang=js&"
export * from "./audio-bar.vue?vue&type=script&lang=js&"
import style0 from "./audio-bar.vue?vue&type=style&index=0&id=6d8ab9ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ab9ec",
  null
  
)

export default component.exports